const isToday = (date: Date) =>
  new Date().toDateString() === date.toDateString();

export const getDateFromISO = (
  dateInISO: string,
  months: string[],
  todayText: string
) => {
  const date = new Date(dateInISO);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const hours = String(date.getHours());
  const minutes = String(date.getMinutes());
  const timeAsString = `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;

  const day = date.getDate();
  const month = months[date.getMonth()];
  const dateAsString = isToday(date) ? todayText : `${day} ${month}`;

  return `${dateAsString} ${timeAsString}`;
};
